import { useCurrentUserContext } from '@/modules/auth/hooks/useCurrentUserContext';
import { UserRole } from '@/types/user';
import {
  BusinessOutlined,
  PeopleOutlined,
  SchoolOutlined,
  SpaceDashboardOutlined,
  SyncAlt,
  TrendingUp,
  ViewListOutlined,
  WebOutlined,
} from '@mui/icons-material';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useLocation } from '@tanstack/react-router';
import React from 'react';

const ROUTES = [
  {
    icon: <SpaceDashboardOutlined />,
    label: 'Home',
    path: '/',
    roles: [],
  },
  {
    icon: <SchoolOutlined />,
    label: 'Courses',
    path: '/courses',
    roles: [UserRole.EducationProvider],
  },
  {
    icon: <ViewListOutlined />,
    label: 'Applications',
    path: '/applications',
    roles: [
      UserRole.Employer,
      UserRole.TaxBenefitsProvider,
      UserRole.EducationProvider,
    ],
  },
  {
    icon: <TrendingUp />,
    label: 'Payments',
    path: '/payments',
    roles: [
      UserRole.Employer,
      UserRole.TaxBenefitsProvider,
      UserRole.EducationProvider,
    ],
  },
  {
    icon: <SyncAlt />,
    label: 'Transactions',
    path: '/learning-budgets/transactions',
    roles: [UserRole.Employer],
  },
  {
    icon: <PeopleOutlined />,
    label: 'Employees',
    path: '/employees',
    roles: [UserRole.Employer],
  },
  {
    icon: <BusinessOutlined />,
    label: 'Companies',
    path: '/companies',
    roles: [UserRole.TaxBenefitsProvider],
  },
  {
    icon: <WebOutlined />,
    label: 'Landing Pages',
    path: '/landing-pages',
    roles: [UserRole.EducationProvider],
  },
];

type SideBarProps = React.HTMLAttributes<HTMLDivElement>;

export function SideBar(props: SideBarProps) {
  const userContext = useCurrentUserContext();
  const location = useLocation();

  return (
    <div
      {...props}
      className={`flex flex-col flex-1 border-r ${props.className ?? ''}`}
    >
      <List disablePadding className="flex flex-col gap-2 px-4 pr-5 pt-4">
        {ROUTES.map(({ icon, label, path, roles }) => {
          if (
            !userContext?.currentUser.roles?.some(role => roles.includes(role))
          ) {
            return null;
          }
          return (
            <ListItem key={path} disablePadding>
              <ListItemButton
                href={path}
                selected={location.pathname === path}
                classes={{
                  selected: 'bg-gray-background',
                  root: 'rounded-lg',
                }}
              >
                <div className="flex gap-2 items-center">
                  <ListItemIcon className="min-w-6 text-mydra-black">
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    className="!text-titles"
                    classes={{
                      primary: 'font-medium text-titles',
                    }}
                    primary={label}
                  />
                </div>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
